







































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Channel } from '@/types/core';

@Component
export default class ReadingList extends Vue {

  @Prop({ default: () => [],  type: Array}) channelList!: Channel[];

  get icons() {
    return {
      'digital': { src:"digital.svg", marginLeft:true},
      'analog': {src:"gauge.svg"},
      'light': {src:"illuminance.svg"},
      'temperature': {src:"temp.svg"},
      'acceleration': {src:"accel.svg"},
      'pressure': {src:"barometer.svg"},
      'humidity': {src:"humidity.svg"},
      'time': {src:"time.svg", marginLeft:true},
      'voltage': {src:"voltage.svg"},
      'percentage': {src:"percentage.svg", height: 14, marginLeft:true}
    }
  }

  formatAccell(value:any, unit:string):string {

    if(typeof value === 'number')
      return `${value}${unit}`;
    else
      return Object.keys(value).map(key => `${key} ${value[key]}${unit}`).join(' | ');

  }
}

